import { combineReducers } from "@reduxjs/toolkit";
import imageUploadSlicer from "../features/imageUpload/imageUpload.slicer";
import instagramSlicer from "../features/instagram/instagram.slicer";
import loginSlicer from "../signIn/signIn.slicer"

const rootReducer = combineReducers({
  imageUpload: imageUploadSlicer,
  instagramSlicer: instagramSlicer,
  loginSlicer: loginSlicer
});

export default rootReducer;
